import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { ContractDetailContractVersionRequestFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Section from 'modules/contracts/components/ContractDetails/Section'

interface Props {
  employeeId: string
  contractVersionRequest: ContractDetailContractVersionRequestFragment
  canPromote: boolean
}

const AboutTheRequest = ({ employeeId, contractVersionRequest, canPromote }: Props) => {
  const {
    access: { id: accessId },
  } = useCurrentSession()
  const { navigation } = useNavigation()
  const status = contractVersionRequest.status
  const canSeeApprovalRequest = () => {
    if (!canPromote || !status) return false

    const approversIds = contractVersionRequest.approversIds
    const currentAccessIsApprover = approversIds?.includes(accessId)

    return canPromote || currentAccessIsApprover
  }

  if (!canSeeApprovalRequest()) return null

  return (
    <Section icon="inbox" title={i18n.t('contract_versions.about_request.title')}>
      <Box flexDirection="row" width="full" justifyContent="spaceBetween" alignItems="center">
        <Text.Normal>
          {i18n.t('contract_versions.about_request.description', {
            authorName: contractVersionRequest?.createdByName || '',
          })}
        </Text.Normal>
        {contractVersionRequest?.id && (
          <Button.Router
            type="secondary"
            to={navigation.employees.id.contractVersions.approval_request.fullPath({
              id: employeeId.toString(),
              contractVersionId: contractVersionRequest?.id?.toString(),
            })}
          >
            {i18n.t('contract_versions.about_request.see_details')}
          </Button.Router>
        )}
      </Box>
    </Section>
  )
}

export default AboutTheRequest
